class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/list/users'
			},
			update_user: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/backend/users/update-own/id'
			},
			create_user: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/users/create-own-user'
			},
			delete: {
				headers: {
					'xt-user-token': null
				},
				method: 'delete',
				path: '/backend/users/delete/:id'
			},
			updateCallPermission: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/users/call-permission/update'
			},
			changeUserDisplayName: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/display/name'
			},
		};
	}
}

export default new APIS();
